import LiveChat from './LiveChat';
import BookingModal from './BookingModal';

export default function SiteWidgets() {
  return (
    <>
      <LiveChat />
      <BookingModal />
    </>
  );
}
